module.exports = __webpack_public_path__ + "img/pack_1.1345f7ed.jpg";